import { render, staticRenderFns } from "./EmailTypologyTable.vue?vue&type=template&id=51ac7fc0&"
import script from "./EmailTypologyTable.vue?vue&type=script&lang=js&"
export * from "./EmailTypologyTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports